<!--
 * @Description: 物流监控/运单轨迹 左边进度条
 * @Author: l_hc
 * @LastEditors: zb
 * @Date: 2019-06-26 11:22:09
 * @LastEditTime: 2019-08-06 11:28:06
 -->
<template>
  <div class="timesline-container">
    <time-line :data="data.wayBill" :start-place="data.startPlace" :end-place="data.stopPlace" />
  </div>
</template>
<script>
import timeline from './timeLine'

export default {
  name: 'Speed',
  components: {
    'time-line': timeline
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      reverse: false,
      successColor: '#0bbd87'
    }
  },
  methods: {
    isArrive(value) {
      if (typeof value === 'string') { return value && value !== '' } else {
        return
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    .timesline-container{
      padding: 0px 16px 0px 0px;
      /deep/.el-timeline{
        position: relative;
        width: 249px;
        margin-left: calc(356px - 265px);
        font-size: 14px;
        .transport-info{
          li{
            height: 18px;
            font-size: 12px;
            line-height: 18px;
          }
        }
      }
    }
</style>
